// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2siFy","clinicsSelect":"TableHeading_clinicsSelect__3i2cC"};